export const SHOW_STATUSES = {
  close: 'close',
  hide: 'hide',
  show: 'show'
}
export const TUTOR_COOKIE_INFO = {
  completedFalse: '',
  completedTrue: 'completed',
  days: 30,
  key: 'TUTOR_COMPLETED_KEY'
}

export const LABELS_LOADER = [
  'Строим дома...',
  'Стрижем газон...',
  'Сажаем деревья...',
  'Укладываем асфальт...',
  'Подметаем улицы...',
  'Рисуем разметку...',
  'Моем окна...',
  'Красим фасады...'
]
